import { createSelector } from 'reselect';
const selector = state => state.products;

export default createSelector([selector], data => data);
